import React, { FC } from "react";

import { Row } from "@/eworkitComponents";

import "./_full-screen-row.scss";

interface IFullScreenRowProps {
  innerBorder?: boolean;
}

/**
 * @deprecated Use iris-based implementation instead.
 */
export const FullScreenRow: FC<IFullScreenRowProps> = ({ ...rowProps }) => {
  const baseClass = "full-screen-row";

  return <Row className={baseClass} {...rowProps} />;
};
